import { render } from "./BasicCheckbox.vue?vue&type=template&id=2aaa6f5e&scoped=true&ts=true"
import script from "./BasicCheckbox.vue?vue&type=script&lang=ts"
export * from "./BasicCheckbox.vue?vue&type=script&lang=ts"

import "./BasicCheckbox.vue?vue&type=style&index=0&id=2aaa6f5e&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/hems-frontend-vue_au_v1.33.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aaa6f5e"]])

export default __exports__